import {
  PRIZE_DRAW_ACTIVE,
  PRIZE_DRAW_CLOSED,
  PRIZE_DRAW_BROKEN,
  PRIZE_DRAW_DRAWN,
  PRIZE_DRAW_SOLD_OUT,
  PRIZE_DRAW_NO_RAFFLE
} from '../../constants';
import { DateTime } from 'luxon';
import logoWall from './foundation-rffle_14_logo-wall.png';

const PrizeHeadline = ({ status, title, description, shortDescription, drawDate, prizes }) => {
  let _title = title;
  let _description = description;
  let _subtitle = false;
  let _drawDateTime = DateTime.fromISO(drawDate);
  let _drawTime = _drawDateTime.toLocaleString(DateTime.TIME_24_SIMPLE);
  let _drawDate = _drawDateTime.toFormat('cccc d LLLL yyyy');
  
  if (status === PRIZE_DRAW_CLOSED) {
    _title = "The Audi Foundation prize draw is now closed";
    _description = `<p>
        Thank you to everyone who entered the prize draw and provided vital funding to local community projects through Australian charities.
        <b>Entries are now closed.</b>
        The draw will take place at ${_drawTime} on ${_drawDate} and the winners will be contacted directly by Audi Australia.
        </p><p>
        Keep up to date on Audi Foundation news by <a href="/subscribe" class="aui-textlink">subscribing here</a>.
        </p><p>
        <img src="${logoWall}" alt="" /><br />You can still support our charity partners by donating to the Audi Foundation directly.
    </p>`;
  }
  
  if (status === PRIZE_DRAW_SOLD_OUT) {
    _title = "The Audi Foundation prize draw is sold out";
    _description = `<p>
        Thank you to everyone who entered the prize draw and provided vital funding to local community projects through Australian charities.
        <b>Entries have sold out.</b>
        The draw will take place at ${_drawTime} on ${_drawDate} and the winners will be contacted directly by the Audi Foundation.
        </p><p>
        You can still support our charity partners by donating to the Audi Foundation directly.
    </p>`;
  }
  
  if (status === PRIZE_DRAW_BROKEN) {
    _title = "Thank you for helping us make a difference.";
    _description = `<p>
      Due to the overwhelming response, we are currently experiencing some delays in processing the competition entries.
      </p><p>
      Please try again later to support a good cause and earn yourself the chance to win.
      </p><p>
      The Audi Foundation Team
    </p>`;
  }
  
  if (status === PRIZE_DRAW_DRAWN) {
    _title = "The prize draw winner has been selected";
    _description = `
      <p>The winner${prizes.length > 1 ? "s were" : " was"} randomly drawn from all eligible entrants at ${_drawTime} on ${_drawDate} at Audi Australia, 895 South Dowling Street, Zetland, New South Wales.
      </p><p><b>Winner: A Man, Beverly Hills NSW<br/>Ticket no. AF01401589 Receipt No. G2CRAQTR.</b>
      </p><p>"It's like an exhilarating rush of disbelief and joy, I couldn't believe it. I want to thank Audi Foundation for their continued dedication to the community and charity partners." - A Man
      </p><p>Thank you to everyone who entered the Audi Foundation prize draw and provided vital funding to local community projects through Australian charities.
      </p><p><img src="${logoWall}" alt="" /><br />You can still support our charity partners by donating to the Audi Foundation directly.</p>
    `
  }
  
  if (status === PRIZE_DRAW_NO_RAFFLE) {
    _subtitle = shortDescription;
  }
  
  return (
    <div className="page-intro mt-0 mb-4 prize-headline cms-section-list">
      <h1>{_title}</h1>
      {_subtitle && <h3>{_subtitle}</h3>}
      <div className="prize-headline__description" dangerouslySetInnerHTML={{ __html: _description }} />
    </div>
  );
}

export default PrizeHeadline;
